import React from 'react';
import { BOSS_DECKS, DIPLOMACY_BREAKDOWN_DECK } from '../../../hooks/useYonotsune.js';
import { getUILoc } from '../../../utils/cardUtils.js';

const FrictionEvent = ({ activeRun, onStartMatch }) => {
  const phase = activeRun.currentPhase;
  const isBreakdown = activeRun.isDiplomacyBreakdown;

  const boss = BOSS_DECKS[activeRun.bossKey];
  const enemyName = isBreakdown 
    ? getUILoc(DIPLOMACY_BREAKDOWN_DECK.nameKey) 
    : (phase === 6 ? (boss ? getUILoc(boss.nameKey) : (activeRun.bossDeckName || activeRun.bossKey || '???')) : `${getUILoc('YONOTSUNE.EVENTS.FRICTION.ENEMY_SIDE')} (${phase})`);
  
  const enemyDesc = isBreakdown 
    ? getUILoc('YONOTSUNE.EVENTS.DIPLOMACY.RESULT_BREAKDOWN') 
    : (phase === 6 ? getUILoc('YONOTSUNE.REWARD_SCREEN.BOSS_REVEAL_DESC') : getUILoc('YONOTSUNE.EVENTS.FRICTION.DESC'));

  return (
    <div className="event-resolver friction-event">
      {isBreakdown ? (
        <div className="breakdown-alert">{getUILoc('YONOTSUNE.EVENTS.FRICTION.BREAKDOWN_ALERT')}</div>
      ) : (
        <div className="friction-alert">{getUILoc('YONOTSUNE.EVENTS.FRICTION.ALERT')}</div>
      )}
      
      <div className="friction-versus-box single-side">
        <div className="side enemy-side">
          <h3>{enemyName}</h3>
          <p className="enemy-desc">{enemyDesc}</p>
          <div className="stats-box unknown-stats">
            <div>{getUILoc('YONOTSUNE.HUD.INIT_CON')}: <span className="text-heal">???</span></div>
            <div>{getUILoc('YONOTSUNE.HUD.INIT_SCALE')}: <span className="text-scale">???</span></div>
          </div>
          <div className="enemy-info">
            {phase === 6 ? (
              <div className="boss-warning">{getUILoc('YONOTSUNE.EVENTS.FRICTION.BOSS_WARNING')}</div>
            ) : (
              <div>{getUILoc('YONOTSUNE.EVENTS.FRICTION.WIN_REWARD')}</div>
            )}
          </div>
        </div>
      </div>

      <div className="action-row">
        <button className="yonotsune-btn battle-btn" onClick={onStartMatch}>
          {getUILoc('YONOTSUNE.EVENTS.START_MATCH')}
        </button>
      </div>
    </div>
  );
};

export default FrictionEvent;
